import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ops/legal/documents/$docId/versions")({
  component: () => <Outlet />,
});
